// extracted by mini-css-extract-plugin
module.exports = {"embedCopyTextarea":"styles_embedCopyTextarea__munjv","embedFeedback":"styles_embedFeedback__1WDCy","embedCopied":"styles_embedCopied__DfSdW"};